import React from "react";
import { AgoraVideoPlayer } from "agora-rtc-react";
import { MicFill, MicMuteFill } from "react-bootstrap-icons";
import { classNames } from "../../../../../general/functions/propsComponent";
import avaDefault from "../../../../../general/assets/img/Propic1.svg";

export default function VideoPlayerPduli(props) {
  const {
    isPresent,
    videoTrack,
    isVideoMute,
    isMicMute,
    title = "title",
    uid,
    isSpeak,
  } = props;
  // console.log(
  //   "videoPlayer check",
  //   title,

  //   isVideoMute || videoTrack,
  //   "videomute",
  //   isVideoMute,
  //   "micMute",
  //   isMicMute,
  //   "videoTrack",
  //   videoTrack,
  //   "isPresent",
  //   isPresent,
  //   "uid",
  //   uid,
  //   "is not video",
  //   isVideoMute || videoTrack == null
  // );
  return (
    <div
      id={"vidComp-" + uid}
      className={classNames(
        isSpeak
          ? "bg-secondary-400"
          : "bg-gradient-to-r from-secondary-900 from-20% via-secondary-600 via-50%  to-secondary-900",
        " relative  p-1 overflow-hidden border",
        isVideoMute ? "border-secondary-500" : "border-secondary-300"
      )}
      // className={classNames(
      //   " relative  p-1 overflow-hidden border",
      //   isVideoMute ? "border-secondary-500" : "border-secondary-300"
      // )}
      style={{ height: "100%" }}
      name={"vidComp-" + uid}
    >
      {isVideoMute || videoTrack == null ? (
        <div className="aspect-video h-full w-full flex items-center justify-center">
          <img
            className="h-20 w-20 rounded-full bg-white p-1 object-center object-cover "
            src={avaDefault}
            alt=""
          />
        </div>
      ) : (
        <AgoraVideoPlayer
          className={classNames("aspect-[9/16] h-full mx-auto  bg-black")}
          style={{ height: "100%", width: "100%" }}
          videoTrack={videoTrack}
        />
      )}

      {isVideoMute == true ? (
        <div className="absolute top-14 left-0 text-white h-full w-full flex justify-center items-center">
          {isPresent && (
            <>
              {isMicMute == true ? (
                <MicMuteFill size={14} className="text-red-500" />
              ) : (
                <MicFill size={14} />
              )}
            </>
          )}
          <div
            className={classNames(
              !isPresent && "pt-6",
              "flex flex-col items-center"
            )}
          >
            <label>{title}</label>

            {!isPresent && <label>Belum Bergabung</label>}
          </div>
        </div>
      ) : (
        <div className="absolute text-white top-0 left-0 px-1 m-1 bg-black line-clamp-1 rounded-sm flex items-center gap-1">
          {isMicMute == true ? (
            <MicMuteFill size={14} className="text-red-500" />
          ) : (
            <MicFill size={14} />
          )}
          <label>{title}</label>
        </div>
      )}
    </div>
  );
}
